/**
 * Scroll reveal for below-the-fold sections.
 *
 * Sections are hidden by JS only after first paint, and only when they sit
 * fully below the viewport at that moment — so there is no flash of hidden
 * content, nothing is ever lost without JS, and the LCP element (always in
 * the initial viewport) is never touched. Reveal is opacity + translate, so
 * layout never shifts (no CLS).
 *
 * Both classes are removed once the transition settles: a lingering
 * `translate` would leave a transform on the section and silently re-parent
 * any position: fixed descendant (sticky bars, dialogs) to it.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /** @param {Element} section */
  const finish = (section) => {
    section.classList.remove('davitta-reveal', 'davitta-reveal--in');
  };

  const arm = () => {
    const sections = document.querySelectorAll('#MainContent .shopify-section');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          const section = entry.target;
          observer.unobserve(section);
          section.classList.add('davitta-reveal--in');
          section.addEventListener('transitionend', () => finish(section), { once: true });
          // Fallback in case the transition never fires (tab hidden, etc.).
          setTimeout(() => finish(section), 900);
        }
      },
      // Fire once the section's top edge is 8% up from the bottom of the
      // viewport, so it never animates fully off-screen.
      { rootMargin: '0px 0px -8% 0px' }
    );

    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      // Skip anything already (partially) on screen or rendering empty.
      if (rect.height === 0 || rect.top < window.innerHeight * 0.92) continue;

      section.classList.add('davitta-reveal');
      observer.observe(section);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm, { once: true });
  } else {
    arm();
  }
})();
